import type {
	ActiveScopeEntry,
	RouteMatch,
} from '@atlassian/post-office-context/post-office-context-scope/types';
import type { PostOfficeContextValue } from '@atlassian/post-office-context/types';
import type { RouteState } from '@atlassian/post-office-context/store/types';
import { createMatchScopes } from '@atlassian/post-office-context/post-office-context-scope';
import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';
import type { ErrorBoundariedProps } from '@post-office/placement-contexts/create-placement-component/types';
import { type ComponentType, memo } from 'react';

import { PLACEMENT_ID } from '../__generated__/common';
import { withScreenSpaceFlagsIntlProvider } from '../__generated__/intl-provider';
import type { Placement as ScreenSpaceFlagsPlacementType } from '../contracts/Placement';
import { scopes } from '../scopes';
import { ScreenSpaceFlagsPlacement } from './placement';

export const matchedScopes = (input: {
	route: RouteState | RouteMatch;
	context: PostOfficeContextValue;
}): ActiveScopeEntry[] => createMatchScopes({ scopes })(input);

export const ScreenSpaceFlagsPlacementComponent: ComponentType<
	ErrorBoundariedProps<ScreenSpaceFlagsPlacementType>
> = withScreenSpaceFlagsIntlProvider(
	createPlacementComponent<ScreenSpaceFlagsPlacementType>(
		PLACEMENT_ID,
		memo((props) => {
			return <ScreenSpaceFlagsPlacement {...props} />;
		}),
		{
			choreographer: {
				isDefaultEnabled: true, // this is the default value, but leaving it as explicitly defined
			},
		},
	),
);

export default ScreenSpaceFlagsPlacementComponent;
